import { render, staticRenderFns } from "./AffiliateBilling.vue?vue&type=template&id=2d8c825a&scoped=true&"
import script from "./AffiliateBilling.vue?vue&type=script&lang=js&"
export * from "./AffiliateBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c825a",
  null
  
)

export default component.exports